export const CAROUSAL_BUTTON = 'BUY NOW';

export const RUPEE_SYMBOL = '₹';

export const HB_PRIME_ROUTE = '/halalbox-select';
